import React, {forwardRef, useEffect, useRef, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {menuButton, textButton} from "../../../../utils/styles";
import {ChevronRight} from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import PropTypes from "prop-types";
import {useLocation, useNavigate} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    paper: {
        maxWidth: 300,
        backgroundColor: theme.palette.primary.light,
        color: 'white'
    },
    subMenuItem: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    ...menuButton(theme),
    ...textButton(theme, false)
}));

const SubMenuItem = forwardRef((props, ref) => {
    const {
        label,
        options,
        onCloseParentMenu,
        onClickMenuBackdrop,
        ...rest
    } = props;
    const classes = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const menuRef = useRef();

    useEffect(() => {
        closeSubmenu();
    }, [location]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeSubmenu = () => {
        setAnchorEl(null);
    };

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            onClickMenuBackdrop && onClickMenuBackdrop(event);
        }

        closeSubmenu();
    };

    const handleSubMenuBackDropClick = event => {
        const rect = menuRef.current.querySelector('.MuiMenu-paper').getBoundingClientRect();

        const clickIsInMenu = event.clientX >= rect.left && event.clientX <= rect.right
            && event.clientY >= rect.top && event.clientY <= rect.bottom;

        if (!clickIsInMenu) {
            closeSubmenu();

            onClickMenuBackdrop && onClickMenuBackdrop(event);
        }
    };

    const handleCloseParentMenu = () => {
        closeSubmenu();

        onCloseParentMenu && onCloseParentMenu();
    };

    const handleClickMenuItem = to => () => {
        navigate(to);

        handleCloseParentMenu();
    };

    return (
        <>
            <MenuItem
                onClick={handleClick}
                className={classes.subMenuItem}
                {...rest}>
                {label}
                <ChevronRight />
            </MenuItem>
            <Menu
                ref={menuRef}
                id={`${label}Submenu`}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                classes={{ paper: classes.paper }}>
                {options.map(option => !option.options ? (
                    <MenuItem
                        key={option.label}
                        onClick={handleClickMenuItem(option.to)}
                        disabled={option.disabled}>
                        {option.label}
                    </MenuItem>
                ) : (
                    <SubMenuItem
                        key={option.label}
                        label={option.label}
                        options={option.options}
                        onCloseParentMenu={handleCloseParentMenu}
                        onClickMenuBackdrop={handleSubMenuBackDropClick} />
                ))}
            </Menu>
        </>
    );
});

SubMenuItem.propTypes = {
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onCloseParentMenu: PropTypes.func,
    onClickMenuBackdrop: PropTypes.func
};

export default SubMenuItem;